import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import IntroSection from "./components/IntroSection";
import InvestorsSection from "./components/InvestorsSection";
import BannerSection from "../components/BannerSection";

const AboutUs = () => {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>About • Beam</title>
        <link rel="canonical" href={`${window.location.origin}${location.pathname}`} />
        <meta
          name="description"
          content={
            "Ultrafast sandbox environments for AI agents. Bring your own custom image and run untrusted code safely – at scale."
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`About • Beam`} />
        <meta
          property="og:description"
          content={
            "Ultrafast sandbox environments for AI agents. Bring your own custom image and run untrusted code safely – at scale."
          }
        />
        <meta property="og:image" content={"https://www.beam.cloud/meta-hero.png"} />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:title" content={`About • Beam`} />
        <meta
          name="twitter:description"
          content={
            "Ultrafast sandbox environments for AI agents. Bring your own custom image and run untrusted code safely – at scale."
          }
        />
        <meta name="twitter:image" content={"https://www.beam.cloud/meta-hero.png"} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <IntroSection />
      {/* <TeamSection /> */}
      <InvestorsSection />
      <BannerSection />
    </>
  );
};

export default AboutUs;
